<template>        
    <div id="appRoot">        
        <template v-if="!$route.meta.public">
            <v-app>                                    
                <app-toolbar class="app--toolbar"></app-toolbar>                
                <app-content class="app--content"></app-content>                        
                <app-right-drawer class="app-right-drawer"></app-right-drawer>  
                <app-fab></app-fab>
                <widget-fetch></widget-fetch>                     
            </v-app>            
        </template>
        <template v-else>
            <transition>
                <keep-alive>
                    <v-slide-y-transition mode="out-in">
                        <router-view></router-view>
                    </v-slide-y-transition>
                </keep-alive>
            </transition>
        </template>
        <app-snackbar></app-snackbar>        
    </div>        
</template>

<script>
import AppFab from './components/app/Fab';
import AppToolbar from './components/app/Toolbar';
import AppRightDrawer from './components/app/RightDrawer';
import AppContent from './components/app/Content';
import AppSnackbar from './components/app/Snackbar';
import WidgetFetch from './components/widgets/Fetch';
import AppEvents from  '@/event';

//import Device from '@/util/models/Device';
import User from '@/util/models/User';
//import Synch from '@/util/models/Synch';


export default {
    name: 'App',
    components: {        
        AppFab,   
        AppToolbar,       
        AppRightDrawer,
        AppContent,
        AppSnackbar,
        WidgetFetch,
    },
    data() {
        return {            
            title: 'Vuetify.js',
            synch: false,
            login: false,            
        }
    },
    created () {
        window.getApp = this;
        
        AppEvents.forEach(item => {
            this.$on(item.name, item.callback);
        });                  
                
    },     
    
}
</script>
<style>
    .v-content{
        min-height: 100%;
        padding-bottom:200px;
    }
    .v-footer{
        position:absolute; bottom:0px; width:100%; height: auto; bottom: 0px; margin-top: 100px;
    } 
    .swal2-container {
        font-family: 'Roboto', sans-serif;
    }
    #swal2-content {
        font-family: arial
    }    
    .cursor{
      cursor: pointer;
    }
</style>
